package org.vreo.devicehub

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.*

import org.vreo.devicehub.navigation.presentation.MainNavigation

@Composable
fun App() {
    MaterialTheme {
        MainNavigation()
    }
}